// extracted by mini-css-extract-plugin
export var button = "Button-module--button--c17ef";
export var colorButton = "Button-module--colorButton--6785a";
export var outlinedButton = "Button-module--outlinedButton--133f8";
export var outlinedButtonSmall = "Button-module--outlinedButtonSmall--e2969";